import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import modal from 'decorators/Modal/Modal';
import { connect } from 'react-redux';
import { userAnnouncements } from 'redux/saga/entities/bound';
import PropTypes from 'prop-types';
import { deepExtract } from 'helpers/deep';
import { acceptAnnouncement } from './announcements.saga';
export var modalConfig = {
  hideClose: true,
  isPersistent: true,
  headerClass: 'modal--small'
};
export var mapDispatchToProps = {
  acceptAnnouncement: acceptAnnouncement
};
export var mapStateToProps = function mapStateToProps(state) {
  return {
    userAnnouncements: userAnnouncements.select(state, userAnnouncements.lastRequestedKey(state))
  };
};
export var AnnouncementsModalUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(AnnouncementsModalUnwrapped, _Component);

  function AnnouncementsModalUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AnnouncementsModalUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnnouncementsModalUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var localUserAnnouncement = _this.props.userAnnouncements;
      var referenceHash = deepExtract('data.announcements.0.reference_hash', localUserAnnouncement);

      _this.props.acceptAnnouncement(referenceHash);
    });

    return _this;
  }

  _createClass(AnnouncementsModalUnwrapped, [{
    key: "render",
    value: function render() {
      var localUserAnnouncement = this.props.userAnnouncements;

      var _deepExtract = deepExtract('data.announcements.0', localUserAnnouncement, {}),
          headerText = _deepExtract.header_text,
          subheaderText = _deepExtract.subheader_text,
          buttonText = _deepExtract.button_text,
          footerLink = _deepExtract.footer_link,
          footerText = _deepExtract.footer_text;

      return React.createElement("div", {
        className: "modal__announcements"
      }, headerText && React.createElement("h3", null, headerText), // eslint-disable-next-line react/no-danger
      subheaderText && React.createElement("p", {
        className: "modal__announcements__subheader mb+ mt",
        dangerouslySetInnerHTML: {
          __html: subheaderText
        }
      }), buttonText && React.createElement("button", {
        className: "bt bt--primary bt--width-full mb",
        onClick: this.handleClick
      }, buttonText), footerLink && footerText && React.createElement("a", {
        href: footerLink,
        className: "modal__announcements__need-help"
      }, footerText));
    }
  }]);

  return AnnouncementsModalUnwrapped;
}(Component);
AnnouncementsModalUnwrapped.propTypes = {
  acceptAnnouncement: PropTypes.func.isRequired,
  userAnnouncements: PropTypes.object.isRequired
};
var AnnouncementsModal = connect(mapStateToProps, mapDispatchToProps)(modal(modalConfig)(AnnouncementsModalUnwrapped));
export { AnnouncementsModal };